module.exports = [
    {
        value: 'server',
        label: 'Server'
    },
    {
        value: 'details',
        label: 'Details'
    },
    {
        value: 'subscription',
        label: 'Subscription'
    },
    {
        value: 'license',
        label: 'License'
    }
];



// WEBPACK FOOTER //
// ./modules/license/services/licenseRegisterNewInstanceWorkflowService.workflowitems.js